import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface FieldProps {
  label: ReactNode;
  /** Shows an "Optional" suffix instead of a red asterisk on required fields. */
  optional?: boolean;
  hint?: ReactNode;
  error?: ReactNode;
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}

/** Sentence-case label above the control, hint or error below. */
export function Field({ label, optional, hint, error, htmlFor, children, className }: FieldProps) {
  const { t } = useTranslation();
  const cls = ['ui-field', error ? 'ui-field--error' : '', className].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <label className="ui-field-label" htmlFor={htmlFor}>
        {label}
        {optional && <span className="ui-field-optional">{t('common.optional')}</span>}
      </label>
      {children}
      {error ? (
        <span className="ui-field-error">{error}</span>
      ) : hint ? (
        <span className="ui-field-hint">{hint}</span>
      ) : null}
    </div>
  );
}

export function FormGrid({ children }: { children: ReactNode }) {
  return <div className="ui-form-grid">{children}</div>;
}
